/**
 * USCIS online account number validation (12 digits).
 * Keep in sync with Portal-Backend/services/uscisAccountValidation.js
 */

export function extractUscisAccountDigits(raw: unknown): string {
  return String(raw ?? "").replace(/\D/g, "");
}

export type UscisAccountValidationResult =
  | { ok: true; normalized: string }
  | { ok: false; message: string };

export function validateUscisAccount(
  raw: unknown,
): UscisAccountValidationResult {
  const digits = extractUscisAccountDigits(raw);

  if (digits.length !== 12) {
    return {
      ok: false,
      message: "Enter a valid 12-digit USCIS online account number.",
    };
  }

  if (/^0+$/.test(digits)) {
    return { ok: false, message: "Enter a valid USCIS online account number." };
  }

  return { ok: true, normalized: digits };
}
